import { render, staticRenderFns } from "./MailCheck.vue?vue&type=template&id=1b8ebd59"
import script from "./MailCheck.vue?vue&type=script&lang=js"
export * from "./MailCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports